import App from "./App.svelte";
import { Amplify } from "aws-amplify";
import { resolveConfig } from "../config/index.js";
import { generateClient } from "aws-amplify/api";
import type { ReteynSchema } from "../schema/index.js";
import { mount } from "svelte";

const config = await resolveConfig();
Amplify.configure({
  ...config,
  Auth: {
    Cognito: {
      allowGuestAccess: true,
      identityPoolId: config.Auth?.Cognito.identityPoolId as string,
    },
  },
});
const client = generateClient<ReteynSchema>({
  authMode: "identityPool",
});

const app = mount(App, {
  target: document.body,
  props: {
    client,
    config,
  },
});
export default app;
